import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { getDatadogActionName } from "@redotech/redo-web/datadog-action-name";

import { useTranslation } from "@redotech/redo-i18n";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { weightOptions } from "../create-label-modal-constants";
import { LabelWeightForm } from "../create-label-modal-forms";

export const LabelWeightInput = memo(function LabelWeightInput({
  labelWeightForm,
  loading,
  "data-dd-action-name": actionName,
}: {
  labelWeightForm: LabelWeightForm;
  loading: boolean;
  "data-dd-action-name"?: string;
}) {
  const { t } = useTranslation();
  return (
    <Flex align="flex-end" gap="md">
      <Flex flex="4">
        <RedoTextInput
          data-dd-action-name={getDatadogActionName(
            actionName,
            "create_label_weight_input",
          )}
          fullWidth
          inputTypeHint="number"
          label={t("Weight")}
          min={0}
          setValue={(value) => {
            const numValue = parseFloat(value) || 0;
            labelWeightForm.inputs.weight.setValue(numValue);
          }}
          size="sm"
          step={undefined}
          value={labelWeightForm.inputs.weight.value.toString()}
        />
      </Flex>
      <Flex flex="1">
        <RedoSingleSelectDropdownInput<WeightUnit>
          data-dd-action-name={getDatadogActionName(
            actionName,
            "create_label_weight_unit_menu_toggle",
          )}
          disabled={loading}
          fullWidth
          options={weightOptions.map((option) => ({
            ...option,
            "data-dd-action-name": getDatadogActionName(
              actionName,
              "create_label_weight_unit_select",
            ),
          }))}
          optionSelected={({ item }) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
            labelWeightForm.inputs.unit.setValue(item.id as WeightUnit);
          }}
          selectedItem={weightOptions.find(
            (option) => option.value === labelWeightForm.inputs.unit.value,
          )}
          size="xs"
        />
      </Flex>
    </Flex>
  );
});
